<nz-layout class="parent">
  <nz-content class="parent">

    @for (tabcont of submenu?.childModules; track tabcont; let j = $index) {
      @if (tabcont.path == componentPaths.arterialBloodGas) {
        <app-arterial-blood-gas [removeMargin]="true" />
      }
      @if (tabcont.path == componentPaths.vitalSigns) {
        <app-vital-signs />
      }
      @if (tabcont.path == componentPaths.glasgow) {
        <app-glasgow />
      }
      @if (tabcont.path == componentPaths.capnography) {
        <app-capnography />
      }
      @if (tabcont.path == componentPaths.complication) {
        <nz-layout class="child">
          <nz-header class="table-header">
            <div fxLayout="row" class="table-header-row">
              <div fxLayout="col" fxLayoutAlign="start center" fxFlex.gt-xl="15" fxFlex.xl="15"
                fxFlex.lt-xl="35" class="title">
                {{"Complications" | translate}}
              </div>
            </div>
          </nz-header>
          <nz-content class="child"><app-complication /></nz-content>
        </nz-layout>
      }
    }

  </nz-content>
</nz-layout>